export default __webpack_public_path__ + "static/media/GoogleResearch.a0df52d6.png";